import { reactive, onMounted, onUnmounted } from 'vue'
import { registerServiceWorker } from './registerSW.js'

const pwaStore = reactive({
    isOnline: navigator.onLine,
    isInstallable: false,
    deferredPrompt: null,
    isInstalled: false,
    version: null,
    syncQueue: [],
    syncStatus: 'idle'
})

export function usePwaStore() {
    return pwaStore
}

export function useSetupPwa({ onNewVersion } = {}) {
    let cleanupFns = []

    function handleOnline() {
        pwaStore.isOnline = true
    }

    function handleOffline() {
        pwaStore.isOnline = false
    }

    function handleBeforeInstallPrompt(e) {
        e.preventDefault()
        pwaStore.isInstallable = true
        pwaStore.deferredPrompt = e
    }

    function handleAppInstalled() {
        pwaStore.isInstallable = false
        pwaStore.deferredPrompt = null
        pwaStore.isInstalled = true
    }

    function handleNewVersion(e) {
        if (typeof onNewVersion === 'function') {
            onNewVersion(e.detail)
        }
    }

    onMounted(() => {
        window.addEventListener('online', handleOnline)
        window.addEventListener('offline', handleOffline)
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
        window.addEventListener('appinstalled', handleAppInstalled)
        window.addEventListener('pwa-new-version', handleNewVersion)

        cleanupFns = [
            () => window.removeEventListener('online', handleOnline),
            () => window.removeEventListener('offline', handleOffline),
            () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt),
            () => window.removeEventListener('appinstalled', handleAppInstalled),
            () => window.removeEventListener('pwa-new-version', handleNewVersion)
        ]

        registerServiceWorker()
    })

    onUnmounted(() => {
        cleanupFns.forEach(fn => fn())
    })
}

export async function installPwa() {
    if (!pwaStore.deferredPrompt) return

    pwaStore.deferredPrompt.prompt()
    const result = await pwaStore.deferredPrompt.userChoice
    pwaStore.deferredPrompt = null

    if (result.outcome === 'accepted') {
        pwaStore.isInstallable = false
    }
}

export { pwaStore }
